import { render, staticRenderFns } from "./OsobaGrupaStatusaEdit.vue?vue&type=template&id=54117b15&scoped=true&"
import script from "./OsobaGrupaStatusaEdit.vue?vue&type=script&lang=js&"
export * from "./OsobaGrupaStatusaEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54117b15",
  null
  
)

export default component.exports